module.exports = __webpack_public_path__ + "media/images/mock-thumbs/event-1-1c086c6d685c010ae3d03587bca1fdb1.png";